module.exports = "@media only screen and (min-width: 821px) {\n  .toggleFuncionario {\n    margin-top: 36px;\n  }\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/recursos-humanos/pessoas/pessoa-form/pessoa-form.component.css
 ** module id = 206
 ** module chunks = 0
 **/